import { Client, QuitEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class QuitEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.QUIT, (event: QuitEvent) => {
            const { nick, ident, hostname, message, time, account, tags, batch } = event;
            const ourNick = this.client?.user.nick;

            if (nick === ourNick) {
                this.tM.closeAllTabs();
            } else {
                const tabs = this.tM.getAllChannelTabs();
                tabs.forEach((tab: any) => {
                    const userPresent = Array.isArray(tab.users) && tab.users.some((u: any) => u && u.nick === nick);
                    if (userPresent) {
                        this.mH.addMessage(tab, `* ${nick} has quit (${message || 'Quit'})`, IRCMessageType.SYSTEM);
                        this.cH.refreshUserList(tab.name);
                    }
                });
            }
        });
    }
}
